import type { ArchiveListing } from './types';
import { t } from '../lib/i18n';

export async function fetchArchives(): Promise<ArchiveListing> {
  const res = await fetch('/api/archives', { credentials: 'same-origin' });
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error(t.errors.daemonOffline);
  return (await res.json()) as ArchiveListing;
}

// Download via a <a download> element. The browser handles the gzip
// stream itself; we never hold the bytes in memory.
export function downloadArchive(stream: string, filename: string): void {
  const a = document.createElement('a');
  a.href = `/api/archives/${encodeURIComponent(stream)}/${encodeURIComponent(filename)}`;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
